/**
 * Log Levels (PSR-3 compatible)
 */
export const LOG_LEVELS = Object.freeze({
    EMERGENCY: 0, // System is unusable
    ALERT: 1,     // Immediate action required
    CRITICAL: 2,  // Critical conditions
    ERROR: 3,     // Error conditions
    WARNING: 4,   // Warning conditions
    NOTICE: 5,    // Normal but significant
    INFO: 6,      // Informational
    DEBUG: 7,     // Debug-level messages
});

/**
 * Log Message Codes
 */
export const LOG_MESSAGES = Object.freeze({
    // 100x — Success / Informational
    1001: { en: "OK", es: "OK", pt: "OK" },
    1002: { en: "Authorized", es: "Authorized", pt: "Authorized" },
    1003: {
        en: "Resource Created Successfully",
        es: "Recurso Creado Exitosamente",
        pt: "Recurso Criado com Sucesso",
    },
    1004: {
        en: "Resource Retrieved Successfully",
        es: "Recurso Recuperado Exitosamente",
        pt: "Recurso Recuperado com Sucesso",
    },
    1005: {
        en: "Resource Updated Successfully",
        es: "Recurso Actualizado Exitosamente",
        pt: "Recurso Atualizado com Sucesso",
    },
    1006: {
        en: "Resource Deleted Successfully",
        es: "Recurso Eliminado Exitosamente",
        pt: "Recurso Deletado com Sucesso",
    },

    // 200x — Non-fatal errors
    2001: { en: "Error", es: "Error", pt: "Error" },
    2002: { en: "Bad Request", es: "Solicitud Incorrecta", pt: "Requisição Inválida" },
    2003: { en: "Unauthorized", es: "No Autorizado", pt: "Não Autorizado" },
    2004: { en: "Forbidden", es: "Prohibido", pt: "Proibido" },
    2005: { en: "Not Found", es: "No Encontrado", pt: "Não Encontrado" },
    2006: {
        en: "Method Not Allowed",
        es: "Método No Permitido",
        pt: "Método Não Permitido",
    },
    2007: {
        en: "Request Timeout",
        es: "Tiempo de Solicitud Agotado",
        pt: "Tempo de Solicitação Esgotado",
    },
    2008: { en: "Conflict", es: "Conflicto", pt: "Conflito" },
    2009: { en: "Gone", es: "Desaparecido", pt: "Desaparecido" },
    2010: {
        en: "Length Required",
        es: "Longitud Requerida",
        pt: "Comprimento Necessário",
    },
    2011: {
        en: "Failed to Create Resource",
        es: "Fallo al Crear el Recurso",
        pt: "Falha ao Criar o Recurso",
    },
    2012: {
        en: "Failed to Retrieve Resource",
        es: "Fallo al Recuperar el Recurso",
        pt: "Falha ao Recuperar o Recurso",
    },
    2013: {
        en: "Failed to Update Resource",
        es: "Fallo al Actualizar el Recurso",
        pt: "Falha ao Atualizar o Recurso",
    },
    2014: {
        en: "Failed to Delete Resource",
        es: "Fallo al Eliminar el Recurso",
        pt: "Falha ao Deletar o Recurso",
    },

    // 300x — Fatal errors
    3001: {
        en: "System Crash",
        es: "System Crash",
        pt: "System Crash",
    },
    3002: {
        en: "Data Corruption Detected",
        es: "Data Corruption Detected",
        pt: "Data Corruption Detected",
    },
    3003: {
        en: "Fatal Security Breach",
        es: "Fatal Security Breach",
        pt: "Fatal Security Breach",
    },
    3004: {
        en: "Hardware Failure",
        es: "Hardware Failure",
        pt: "Hardware Failure",
    },
    3005: {
        en: "Unrecoverable Database Error",
        es: "Unrecoverable Database Error",
        pt: "Unrecoverable Database Error",
    },
    3006: {
        en: "Critical Service Unavailable",
        es: "Critical Service Unavailable",
        pt: "Critical Service Unavailable",
    },
});

/**
 * Semantic aliases (optional)
 */
export const LOG_MESSAGE_CODES = Object.freeze({
    OK: 1001,
    AUTHORIZED: 1002,
    RESOURCE_CREATED: 1003,
    RESOURCE_RETRIEVED: 1004,
    RESOURCE_UPDATED: 1005,
    RESOURCE_DELETED: 1006,

    ERROR: 2001,
    BAD_REQUEST: 2002,
    UNAUTHORIZED: 2003,
    FORBIDDEN: 2004,
    NOT_FOUND: 2005,

    SYSTEM_CRASH: 3001,
});
